














import Vue from 'vue';

export default Vue.extend({
  name: 'ErrorMessage',
  props: {
    errorMessage: {
      type: String,
      required: true,
    },
  },
});
